import { ListItemButton, ListItemIcon } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootAppState } from "../../redux/store";
import { RouteType } from "../../routes/config";
import colorConfigs from "../../configs/colorConfigs";
import { useSessao } from "../../redux/sessao/sessaoHooks";
import { useEmpresa } from "../../redux/empresa/empresaHooks";

type Props = {
  item: RouteType;
  closeDrawer: () => void;
};

const SidebarItem = ({ item, closeDrawer }: Props) => {
  const { appState } = useSelector((state: RootAppState) => state.appState);
  const [sessao] = useSessao();
  const [empresa] = useEmpresa();

  return item.sidebarProps &&
    item.path &&
    item.show &&
    (item.verificarPermissao
      ? item.verificarPermissao(sessao.usuario, empresa)
      : true) ? (
    <ListItemButton
      onClick={closeDrawer}
      component={Link}
      to={item.path}
      sx={{
        paddingLeft: 2, // Aumenta o padding conforme o nível do item
        backgroundColor:
          appState === item.state ? colorConfigs.sidebar.activeBg : "unset",
        width: "103%",
        borderRadius: "5px",
        "&: hover": {
          backgroundColor: colorConfigs.sidebar.hoverBg,
          borderRadius: "5px",
        },
      }}
    >
      <ListItemIcon
        sx={{
          color: colorConfigs.sidebar.bg,
        }}
      >
        {item.sidebarProps.icon && item.sidebarProps.icon}
      </ListItemIcon>
      {item.sidebarProps.displayText}
    </ListItemButton>
  ) : null;
};

export default SidebarItem;
